<template>
  <div>
    <ModalProvider v-if="isAppReady">
      <RouterView />
    </ModalProvider>
    <div
      ref="modalTarget"
      class="modal-target"
    />
  </div>
</template>

<script lang="ts" setup>
  import './styles.scss';

  import { captureException } from '@experience/core-hostapp-share-lib';
  import { ModalProvider } from '@experience/core-modal-ui';
  import { initHotReloader, setCssFilesLinksAttribute } from '@experience/vite-plugin-wc-extract-styles';
  import { nextTick, onErrorCaptured, onMounted, provide, ref, useShadowRoot } from 'vue';
  import { useRouter } from 'vue-router';

  import { initApiClient } from '@/shared/api/apiClient';
  import { MF_NAME } from '@/shared/config/env';
  import { getRuntimeConfig } from '@/shared/config/runtime';
  import { trackBranchExperiment } from '@/shared/lib/experiments';

  const sentryDsn = getRuntimeConfig().VITE_RUNTIME_SENTRY_DSN;

  onErrorCaptured((err) => {
    captureException(err, { mf: MF_NAME, dsn: sentryDsn, mfRelease: __APP_VERSION__ });
  });

  // конфигурируем общий API-клиент до рендера дочерних компонентов;
  // аналитика инициализируется лениво при первом useAnalytics()
  initApiClient();
  trackBranchExperiment(import.meta.env.VITE_EXPERIMENT_NAME);

  const router = useRouter();
  const isAppReady = ref(false);
  const shadowRoot = useShadowRoot();
  const modalTarget = ref<HTMLElement | null>(null);

  // Сохраняем прежний порядок инициализации: страница рендерится только после готовности роутера.
  onMounted(async () => {
    await router.isReady();
    await nextTick();

    isAppReady.value = true;

    // Помечаем завершение первой загрузки после отображения skeleton.
    window.setTimeout(() => {
      sessionStorage.setItem('skeleton-lib:page-loaded', 'true');
    }, 100);
  });

  provide('shadowRoot', shadowRoot);
  provide('modalTarget', modalTarget);

  initHotReloader(import.meta.hot, shadowRoot);

  setCssFilesLinksAttribute(
    shadowRoot,
    import.meta.env.MODE === 'production' ? `/mfs/${MF_NAME}/` : '/',
    'data-external-style-url',
    '%%PROD_STYLESHEET_FILE_LINK%%',
    '',
  );
</script>
